import { BASE_PATH as R, BaseAPI as U, operationServerMap as C } from "../base.js";
import { DUMMY_BASE_URL as p, assertParamExists as c, createRequestFunction as v, serializeDataIfNeeded as A, setSearchParams as O, toPathString as V } from "../common.js";
import y from "axios";
var I = function(o) {
  return {
    merchantCommissionRuleApplyProductRuleToOrders: async (i, t, n = {}) => {
      c("merchantCommissionRuleApplyProductRuleToOrders", "ruleId", i), c("merchantCommissionRuleApplyProductRuleToOrders", "productCommissionRuleApplyRequest", t);
      const r = "/merchant/commission/rule/{ruleId}/apply-product-orders".replace("{ruleId}", encodeURIComponent(String(i))), e = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...n
      }, a = {}, m = {};
      a["Content-Type"] = "application/json", O(e, m);
      let u = s && s.headers ? s.headers : {};
      return l.headers = {
        ...a,
        ...u,
        ...n.headers
      }, l.data = A(t, l, o), {
        url: V(e),
        options: l
      };
    },
    merchantCommissionRuleCreateCommissionRule: async (i, t = {}) => {
      c("merchantCommissionRuleCreateCommissionRule", "merchantCommissionRuleDTO", i);
      const n = new URL("/merchant/commission/rule", p);
      let r;
      o && (r = o.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", O(n, l);
      let a = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...a,
        ...t.headers
      }, e.data = A(i, e, o), {
        url: V(n),
        options: e
      };
    },
    merchantCommissionRuleDeleteCommissionRule: async (i, t = {}) => {
      c("merchantCommissionRuleDeleteCommissionRule", "ruleId", i);
      const n = "/merchant/commission/rule/{ruleId}".replace("{ruleId}", encodeURIComponent(String(i))), r = new URL(n, p);
      let e;
      o && (e = o.baseOptions);
      const s = {
        method: "DELETE",
        ...e,
        ...t
      }, l = {};
      O(r, {});
      let a = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...a,
        ...t.headers
      }, {
        url: V(r),
        options: s
      };
    },
    merchantCommissionRuleGetCommissionRuleDetail: async (i, t, n = {}) => {
      c("merchantCommissionRuleGetCommissionRuleDetail", "ruleId", i), c("merchantCommissionRuleGetCommissionRuleDetail", "page", t);
      const r = "/merchant/commission/rule/{ruleId}".replace("{ruleId}", encodeURIComponent(String(i))), e = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const l = {
        method: "GET",
        ...s,
        ...n
      }, a = {}, m = {};
      if (t !== void 0) for (const [h, S] of Object.entries(t)) m[h] = S;
      O(e, m);
      let u = s && s.headers ? s.headers : {};
      return l.headers = {
        ...a,
        ...u,
        ...n.headers
      }, {
        url: V(e),
        options: l
      };
    },
    merchantCommissionRuleGetCommissionRuleList: async (i, t, n = {}) => {
      c("merchantCommissionRuleGetCommissionRuleList", "shopId", i);
      const r = "/merchant/commission/rule/list/{shopId}".replace("{shopId}", encodeURIComponent(String(i))), e = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const l = {
        method: "GET",
        ...s,
        ...n
      }, a = {}, m = {};
      t !== void 0 && (m.ruleType = t), O(e, m);
      let u = s && s.headers ? s.headers : {};
      return l.headers = {
        ...a,
        ...u,
        ...n.headers
      }, {
        url: V(e),
        options: l
      };
    },
    merchantCommissionRuleGetEffectiveCommissionEmployees: async (i = {}) => {
      const t = new URL("/merchant/commission/rule/effective-employees", p);
      let n;
      o && (n = o.baseOptions);
      const r = {
        method: "GET",
        ...n,
        ...i
      }, e = {};
      O(t, {});
      let s = n && n.headers ? n.headers : {};
      return r.headers = {
        ...e,
        ...s,
        ...i.headers
      }, {
        url: V(t),
        options: r
      };
    },
    merchantCommissionRuleUpdateCommissionRule: async (i, t = {}) => {
      c("merchantCommissionRuleUpdateCommissionRule", "merchantCommissionRuleDTO", i);
      const n = new URL("/merchant/commission/rule", p);
      let r;
      o && (r = o.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", O(n, l);
      let a = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...a,
        ...t.headers
      }, e.data = A(i, e, o), {
        url: V(n),
        options: e
      };
    },
    merchantCommissionRuleUpdateCommissionRuleStatus: async (i, t, n = {}) => {
      c("merchantCommissionRuleUpdateCommissionRuleStatus", "ruleId", i), c("merchantCommissionRuleUpdateCommissionRuleStatus", "status", t);
      const r = "/merchant/commission/rule/{ruleId}/status/{status}".replace("{ruleId}", encodeURIComponent(String(i))).replace("{status}", encodeURIComponent(String(t))), e = new URL(r, p);
      let s;
      o && (s = o.baseOptions);
      const l = {
        method: "PUT",
        ...s,
        ...n
      }, a = {};
      O(e, {});
      let m = s && s.headers ? s.headers : {};
      return l.headers = {
        ...a,
        ...m,
        ...n.headers
      }, {
        url: V(e),
        options: l
      };
    }
  };
}, d = function(o) {
  const i = I(o);
  return {
    async merchantCommissionRuleApplyProductRuleToOrders(t, n, r) {
      var e, s;
      const l = await i.merchantCommissionRuleApplyProductRuleToOrders(t, n, r), a = (e = o == null ? void 0 : o.serverIndex) !== null && e !== void 0 ? e : 0, m = (s = C["MerchantCommissionRuleApi.merchantCommissionRuleApplyProductRuleToOrders"]) === null || s === void 0 || (s = s[a]) === null || s === void 0 ? void 0 : s.url;
      return (u, h) => v(l, y, R, o)(u, m || h);
    },
    async merchantCommissionRuleCreateCommissionRule(t, n) {
      var r, e;
      const s = await i.merchantCommissionRuleCreateCommissionRule(t, n), l = (r = o == null ? void 0 : o.serverIndex) !== null && r !== void 0 ? r : 0, a = (e = C["MerchantCommissionRuleApi.merchantCommissionRuleCreateCommissionRule"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => v(s, y, R, o)(m, a || u);
    },
    async merchantCommissionRuleDeleteCommissionRule(t, n) {
      var r, e;
      const s = await i.merchantCommissionRuleDeleteCommissionRule(t, n), l = (r = o == null ? void 0 : o.serverIndex) !== null && r !== void 0 ? r : 0, a = (e = C["MerchantCommissionRuleApi.merchantCommissionRuleDeleteCommissionRule"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => v(s, y, R, o)(m, a || u);
    },
    async merchantCommissionRuleGetCommissionRuleDetail(t, n, r) {
      var e, s;
      const l = await i.merchantCommissionRuleGetCommissionRuleDetail(t, n, r), a = (e = o == null ? void 0 : o.serverIndex) !== null && e !== void 0 ? e : 0, m = (s = C["MerchantCommissionRuleApi.merchantCommissionRuleGetCommissionRuleDetail"]) === null || s === void 0 || (s = s[a]) === null || s === void 0 ? void 0 : s.url;
      return (u, h) => v(l, y, R, o)(u, m || h);
    },
    async merchantCommissionRuleGetCommissionRuleList(t, n, r) {
      var e, s;
      const l = await i.merchantCommissionRuleGetCommissionRuleList(t, n, r), a = (e = o == null ? void 0 : o.serverIndex) !== null && e !== void 0 ? e : 0, m = (s = C["MerchantCommissionRuleApi.merchantCommissionRuleGetCommissionRuleList"]) === null || s === void 0 || (s = s[a]) === null || s === void 0 ? void 0 : s.url;
      return (u, h) => v(l, y, R, o)(u, m || h);
    },
    async merchantCommissionRuleGetEffectiveCommissionEmployees(t) {
      var n, r;
      const e = await i.merchantCommissionRuleGetEffectiveCommissionEmployees(t), s = (n = o == null ? void 0 : o.serverIndex) !== null && n !== void 0 ? n : 0, l = (r = C["MerchantCommissionRuleApi.merchantCommissionRuleGetEffectiveCommissionEmployees"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (a, m) => v(e, y, R, o)(a, l || m);
    },
    async merchantCommissionRuleUpdateCommissionRule(t, n) {
      var r, e;
      const s = await i.merchantCommissionRuleUpdateCommissionRule(t, n), l = (r = o == null ? void 0 : o.serverIndex) !== null && r !== void 0 ? r : 0, a = (e = C["MerchantCommissionRuleApi.merchantCommissionRuleUpdateCommissionRule"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => v(s, y, R, o)(m, a || u);
    },
    async merchantCommissionRuleUpdateCommissionRuleStatus(t, n, r) {
      var e, s;
      const l = await i.merchantCommissionRuleUpdateCommissionRuleStatus(t, n, r), a = (e = o == null ? void 0 : o.serverIndex) !== null && e !== void 0 ? e : 0, m = (s = C["MerchantCommissionRuleApi.merchantCommissionRuleUpdateCommissionRuleStatus"]) === null || s === void 0 || (s = s[a]) === null || s === void 0 ? void 0 : s.url;
      return (u, h) => v(l, y, R, o)(u, m || h);
    }
  };
}, G = function(o, i, t) {
  const n = d(o);
  return {
    merchantCommissionRuleApplyProductRuleToOrders(r, e) {
      return n.merchantCommissionRuleApplyProductRuleToOrders(r.ruleId, r.productCommissionRuleApplyRequest, e).then((s) => s(t, i));
    },
    merchantCommissionRuleCreateCommissionRule(r, e) {
      return n.merchantCommissionRuleCreateCommissionRule(r.merchantCommissionRuleDTO, e).then((s) => s(t, i));
    },
    merchantCommissionRuleDeleteCommissionRule(r, e) {
      return n.merchantCommissionRuleDeleteCommissionRule(r.ruleId, e).then((s) => s(t, i));
    },
    merchantCommissionRuleGetCommissionRuleDetail(r, e) {
      return n.merchantCommissionRuleGetCommissionRuleDetail(r.ruleId, r.page, e).then((s) => s(t, i));
    },
    merchantCommissionRuleGetCommissionRuleList(r, e) {
      return n.merchantCommissionRuleGetCommissionRuleList(r.shopId, r.ruleType, e).then((s) => s(t, i));
    },
    merchantCommissionRuleGetEffectiveCommissionEmployees(r) {
      return n.merchantCommissionRuleGetEffectiveCommissionEmployees(r).then((e) => e(t, i));
    },
    merchantCommissionRuleUpdateCommissionRule(r, e) {
      return n.merchantCommissionRuleUpdateCommissionRule(r.merchantCommissionRuleDTO, e).then((s) => s(t, i));
    },
    merchantCommissionRuleUpdateCommissionRuleStatus(r, e) {
      return n.merchantCommissionRuleUpdateCommissionRuleStatus(r.ruleId, r.status, e).then((s) => s(t, i));
    }
  };
}, T = class extends U {
  merchantCommissionRuleApplyProductRuleToOrders(o, i) {
    return d(this.configuration).merchantCommissionRuleApplyProductRuleToOrders(o.ruleId, o.productCommissionRuleApplyRequest, i).then((t) => t(this.axios, this.basePath));
  }
  merchantCommissionRuleCreateCommissionRule(o, i) {
    return d(this.configuration).merchantCommissionRuleCreateCommissionRule(o.merchantCommissionRuleDTO, i).then((t) => t(this.axios, this.basePath));
  }
  merchantCommissionRuleDeleteCommissionRule(o, i) {
    return d(this.configuration).merchantCommissionRuleDeleteCommissionRule(o.ruleId, i).then((t) => t(this.axios, this.basePath));
  }
  merchantCommissionRuleGetCommissionRuleDetail(o, i) {
    return d(this.configuration).merchantCommissionRuleGetCommissionRuleDetail(o.ruleId, o.page, i).then((t) => t(this.axios, this.basePath));
  }
  merchantCommissionRuleGetCommissionRuleList(o, i) {
    return d(this.configuration).merchantCommissionRuleGetCommissionRuleList(o.shopId, o.ruleType, i).then((t) => t(this.axios, this.basePath));
  }
  merchantCommissionRuleGetEffectiveCommissionEmployees(o) {
    return d(this.configuration).merchantCommissionRuleGetEffectiveCommissionEmployees(o).then((i) => i(this.axios, this.basePath));
  }
  merchantCommissionRuleUpdateCommissionRule(o, i) {
    return d(this.configuration).merchantCommissionRuleUpdateCommissionRule(o.merchantCommissionRuleDTO, i).then((t) => t(this.axios, this.basePath));
  }
  merchantCommissionRuleUpdateCommissionRuleStatus(o, i) {
    return d(this.configuration).merchantCommissionRuleUpdateCommissionRuleStatus(o.ruleId, o.status, i).then((t) => t(this.axios, this.basePath));
  }
};
export {
  T as MerchantCommissionRuleApi,
  I as MerchantCommissionRuleApiAxiosParamCreator,
  G as MerchantCommissionRuleApiFactory,
  d as MerchantCommissionRuleApiFp
};

//# sourceMappingURL=merchant-commission-rule-api.js.map